import { ErrorMessage, Field, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { SymptomIntialValues, SymptomValidationSchema } from "../../constant";
import { useMutateEditSymptom } from "../../hooks/useApiHook";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import InputWithLabel from "../../../../Components/InputWithLabel";
import { Switch } from "../../../../Components";
import { useQuery } from "@tanstack/react-query";
import { GetSingleSymptom } from "../../../../Api/Symptom";
import BackButton from "../../../../Components/BackButton";
import SaveButton from "../../../../Components/SaveButton";

const EditSymptom = () => {
  const navigate = useNavigate();
  const formRef = useRef();
  const stateData = useLocation();

  const { id } = stateData?.state || "";

  const editSymptomApi = useMutateEditSymptom();
  const [isLoading, setIsLoading] = useState(false);

  const { data } = useQuery({
    queryKey: ["get-single-symptom"],
    queryFn: () => GetSingleSymptom(id),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  useEffect(() => {
    if (data) {
      if (formRef?.current?.values) {
        formRef?.current?.setValues({
          name: data?.data?.name,
          isOnboarded: data?.data?.isOnboarded
        });
      }
    }
  }, [data]);

  function getLastNameFromUrl(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  const handleSubmitEditSYmptom = (values) => {
    const reqData = {
      symptomId: id,
      name: values?.name,
      isOnboarded: values?.isOnboarded
    };

    setIsLoading(true);
    editSymptomApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || " Product Updated.");
        navigate("/admin/symptom");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };
  return (
    <>
      <Helmet>
        <title>OVE | Admin Edit Symptom</title>
      </Helmet>
      <div className="symptom-page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card symptom-card-border overflow-visible">
                <div className="symptom-card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Edit Symptom</h3>
                      </div>
                      <div className="col-auto d-flex align-items-center justify-content-center">
                        <BackButton to="/admin/symptom" />
                      </div>
                    </div>
                  </div>

                  <Formik
                    initialValues={SymptomIntialValues}
                    validationSchema={SymptomValidationSchema}
                    validateOnChange
                    innerRef={formRef}
                    onSubmit={handleSubmitEditSYmptom}
                  >
                    {(formik) => {
                      const { setFieldValue, values, setFieldTouched } = formik;
                      return (
                        <Form>
                          <section className="symptom-section-border">
                            <div className="row">
                              <div className="col-md-6">
                                <Field
                                  Label="Name"
                                  type="text"
                                  name="name"
                                  placeholder="Enter Symptom Name"
                                  component={InputWithLabel}
                                />
                              </div>

                              <div className="form-group col-md-6">
                                <label className="d-block">Is Onboarded</label>
                                <div className="switch-handler">
                                  <Switch
                                    name="isOnboarded"
                                    checked={values.isOnboarded}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "isOnboarded",
                                        e.target.checked
                                      );
                                    }}
                                    color="primary"
                                    size="medium"
                                  />
                                </div>
                                <ErrorMessage
                                  name="isOnboarded"
                                  component="span"
                                  className="error d-block"
                                />
                              </div>
                            </div>
                            <SaveButton loading={isLoading} />
                          </section>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSymptom;
